/**
 * Accor Plus API calls
 * Date Created: 01/07/2022
 */

import Helper from '../common/helper';

let payments_base_url       = "https://payments-api-uat.accorplus.com";
let payments_url_version    = "v1";
let payments_api_version    = "/v1";
let integration_base_url    = "";
let integration_api_version = "";

if(window.location.host == "accorplus.com" || window.location.host == "www.accorplus.com" || window.location.host == "nprod.accorplus.com"|| window.location.host == "www.accorplusdev.com") {
    payments_base_url       = "https://payments-api.accorplus.com/";
    payments_api_version    = "v1";
    integration_base_url    = "https://int-api.accorplus.com/";
    integration_api_version = "v1";
} else {
    payments_base_url       = "https://payments-api-uat.accorplus.com/";
    payments_api_version    = "v1";

    integration_base_url    = "https://api-uat.accorplus.com/";
    integration_api_version = "v1";
}

let headers =  new Headers({
    'Content-Type': 'application/json',
})

let headers2 =  new Headers({
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
})

// let headersApiKey =  new Headers({
//     'Access-Control-Allow-Origin': '*',
//     'Content-Type': 'application/json',
//     'Authorization': `Bearer ${apiKey}`,
// })


const ApiService = {
    userdata: async function() {
        let json, token;
        if(document.cookie) {
            json = document.cookie.split('; ').reduce((prev, current) => {
                const [name, ...value] = current.split('=');
                prev[name] = value.join('=');
                return prev;
            }, {});
        
            /*if(json.token) {
                token = JSON.parse(unescape(json.token));
            }*/
            if(json.accorUserData) {
                token = JSON.parse(unescape(json.accorUserData));
                return token;
            }
        }

        //no user data detected
        return false;

        /*return fetch(payments_base_url + payments_api_version + "/member/me", {
            method: 'GET',
            "headers": new Headers({
                // 'Authorization': 'Bearer ' + "eyJhbGciOiJSUzI1NiIsImtpZCI6IkFaRXhjZHp6dnFxUVRBRFZFMTI4U1pOQlFLU0R4aGR6QVFmeHhoZGNkdnV6MTIzc2ZjIiwicGkuYXRtIjoiM2F3ZiJ9.eyJzY3AiOiJBUElXRUIuVVNFUi5XUklURV9QUk9GSUxFIG9wZW5pZCBBUElXRUIuVVNFUi5SRUFEX1BST0ZJTEUgQVBJV0VCLlVTRVIuV0FMTEVUIiwiY2xpZW50SWQiOiJjb20uYWNjb3JwbHVzIiwiY29udGFjdElkIjoiMTAwMDAxMDgzODcyMzcwIiwidG9rZW5fdXNlIjoiYWNjZXNzIiwicG1pZCI6IjA1MDg4MzlBIiwiZXhwIjoxNjYyMzU0NDIyfQ.NfvT3zchlSU_3_01fJJ6Ri2XoMMnZNN4nZ5NwuJQ06OuoEZtGKSnAXWnxXUVcEfZvZJOFMw6ejlu2x6kVgRSSSfPXA58BneXSwxg47VG1bHPq20342no1XRhz7IlfQwa_sZd9a4AQpNfPTNUAXElL87TYqVbZpmJ5fpC4tBAJOlNXOpwwnGaq-7s8JzJ_FBySeljddD--Ebe27rqqw9CEZkfysHAEbhHgVY8-EFdVVbOMCCBLTIkVzM1gyoOSXKUH9L0rkvrx8rq261QVR488MgFnwJYoOM9lTKr0PqKTx5ra3MHrOHXuXCCcQiPmeSYoclljB9PfbxHLwB609ibZg",
                //'Authorization': 'Bearer ' + "eyJhbGciOiJSUzI1NiIsImtpZCI6IkFaRXhjZHp6dnFxUVRBRFZFMTI4U1pOQlFLU0R4aGR6QVFmeHhoZGNkdnV6MTIzc2ZjIiwicGkuYXRtIjoiM2F3ZiJ9.eyJzY3AiOiJBUElXRUIuVVNFUi5XUklURV9QUk9GSUxFIG9wZW5pZCBBUElXRUIuVVNFUi5SRUFEX1BST0ZJTEUgQVBJV0VCLlVTRVIuV0FMTEVUIiwiY2xpZW50SWQiOiJjb20uYWNjb3JwbHVzIiwiY29udGFjdElkIjoiMTAwMDAxMDgzODcyMzcwIiwidG9rZW5fdXNlIjoiYWNjZXNzIiwicG1pZCI6IjA1MDg4MzlBIiwiZXhwIjoxNjY2MzMyODUyfQ.K6NPnw7Y7hbrYHMBLuHLAZmUsg2xdT_z3TySHafgk-99rjfVVQff0f9z6SJ0nh4DfQ0P1qvE2CPNVhfQAC8aYZOiCH2nmOkcHMVjOvgUGgFo2H5XBE2rgrnsmozS8812VyJzw2ZT2fXIe6lltx9BNhNWMNMntRtVpd3XKgxQ0AltpwJciLNK_Awia9EmpQYQFv4O4XnKN4DC39TlqUscxL8297veCorUCv_JYM9-PN2bZi_Yt9apzCeZwi-BBEHdQqG_S31cJ8AtJwW1tJluvwnsZXUum9Xn72WMVmUwYY-CWdWBAwLKnE_3xixzT0Q7gBmy23T-Dgy6IvlI14v01w",
                'Authorization': 'Bearer ' + token.access_token,
                'Content-Type': 'application/json'
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {return responseJson});*/
    },

    getLanguages: function() {
        return fetch(Helper.getUrl().googleApiUrl, {
            method: "GET",
            dataType: 'json',
            headers2

        });
    },

    getLocationData: function(params) {
        let data = ((params) ? Helper.jsonToUrlParameters(params) : "");
        return fetch(payments_base_url + payments_api_version + "/functions/locationdata" + data, {
            method:"GET",
            headers2
        });
    },

    getProducts: function(bc, subsidiary, language, pricelevel, ui_channel) {
        let date = new Date();
        let day = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
        let dateToday = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + day;
    
        let data = {
            "subsidiary": subsidiary,
            "language": language || "en-au",
            "date": dateToday,
            "ui_channel": ui_channel
        };
    
        if(pricelevel) {
            data["pricelevel"] = pricelevel;
        } else {
            data["bc"] = bc;
        }

        if(ui_channel) {
            data["pricelevel"] = null;
            data["bc"] = null;
        }

        return fetch(payments_base_url + payments_api_version + "/products/membership", {
            method:"POST",
            headers,
            body:JSON.stringify(data)
        });

        // Sandbox BC structure for PWP check has been changed -> using the prod Membership to check the products with the old PWP structure
        // return fetch('https://payments-api.accorplus.com/' + payments_api_version + "/products/membership", {
        //     method:"POST",
        //     headers,
        //     body:JSON.stringify(data)
        // });
    },

    createTransaction: async function(params) {
        let data = JSON.stringify(params);

        return fetch(payments_base_url + payments_api_version + "/transactions", {
            method:"POST",
            headers,
            body:data
        })
        .then((response) => response.json())
        .then((responseJson) => {return responseJson});
    },
    
    createOrderItems: async function(id, params) {
        let date = new Date();
        let day = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
        let dateToday = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + day;
    
        params["date"] = dateToday;
    
        let data = JSON.stringify(params);

        return fetch(payments_base_url + payments_api_version + `/transactions/${id}/orderitems`, {
            method:"POST",
            headers,
            body: data
        })
        .then((response) => response.json())
        .then((responseJson) => {return responseJson});
    },

    asiaPayDirectLink: async function(params) {
        let data = JSON.stringify(params);
        
        return fetch(payments_base_url + payments_api_version + "/transactions/merchant/asiapay/directlink", {
            method:"POST",
            headers,
            body: data
        })
        .then((response) => response.json())
        .then((responseJson) => {return responseJson});
    },

    asiaPayDirectClient: function(params) {
        let data = JSON.stringify(params);

        return fetch(payments_base_url + payments_api_version + "/transactions/merchant/asiapay/directclient", {
            method:"POST",
            headers,
            body: data
        })
        .then((response) => response.json())
        .then((responseJson) => {return responseJson});
    },
    
    limePayCreateOrder: function(params) {
        let data = JSON.stringify(params);

        // return fetch(payments_base_url + payments_api_version + "/transactions/merchant/limepay/order", {
        return fetch(payments_base_url + payments_api_version + "/transactions/merchant/limepay-v3/order", {
            method:"POST",
            headers,
            body: data
        })
        .then((response) => response.json())
        .then((responseJson) => {return responseJson});
    },
    
    limePayCreatePayment: function(params) {
        let data = JSON.stringify(params);

        // return fetch(payments_base_url + payments_api_version + "/transactions/merchant/limepay/payment", {
        return fetch(payments_base_url + payments_api_version + "/transactions/merchant/limepay-v3/payment", {
            method:"POST",
            headers,
            body: data
        })
        .then((response) => response.json())
        .then((responseJson) => {return responseJson});
    },

    stripeCreateSubscription: function(params) {
        let data = JSON.stringify(params);

        return fetch(payments_base_url + payments_api_version + "/transactions/merchant/stripe/createsubscription", {
            method:"POST",
            headers,
            body: data
        });
    },
    
    stripeCreatePaymentIntent: function(params) {
        let data = JSON.stringify(params);

        return fetch(payments_base_url + payments_api_version + "/transactions/merchant/stripe/createpaymentintent", {
            method:"POST",
            headers,
            body: data
        });
    },

    payWithPointsPayment: function(params) {
        let data = JSON.stringify(params);

        return fetch(payments_base_url + payments_api_version + "/transactions/merchant/paywithpoints", {
            method:"POST",
            headers,
            body: data
        });
    },

    // getLanguages: function() {
    //     return fetch(Helper.getUrl().googleApiUrl, {
    //         method: "GET",
    //         dataType: 'json',
    //     });
    // },

    // getLocationData: function(params) {
    //     let data = ((params) ? Helper.jsonToUrlParameters(params) : "");
    //     return fetch(payments_base_url + payments_api_version + "/functions/locationdata" + data, {
    //         method:"GET",
    //         headers
    //     });
    // },

    getCouponData: function(params) {
        let data = ((params) ? Helper.jsonToUrlParameters(params) : "");
        return fetch(payments_base_url + payments_api_version + "/promotions/coupon" + data, {
            method:"POST",
            headers,
            body:JSON.stringify(params)
        });
    },

    getRenewalData: function(pmid, date) {
        return fetch(payments_base_url + payments_api_version + `/member/renew/opportunity?pmid=${pmid}&date=${date}`, {
            method:"GET",
            headers
        });
    },

    getExpressRenewalData: function(hash, date) {
        return fetch(payments_base_url + payments_api_version + `/member/renew/express?hash=${hash}&date=${date}`, {
            method:"GET",
            headers
        });
    },
    
    qbrEligible: function(params) {
        return fetch(integration_base_url + integration_api_version + "/qbr/eligible", {
            method:"POST",
            headers,
            body:JSON.stringify(params)
        });
    },

    qbrJoin: function(params) {
        return fetch(integration_base_url + integration_api_version + "/qbr/join", {
            method:"POST",
            headers,
            body:JSON.stringify(params)
        });
    },

    memberStatus: function(params, apiKey) {
        return fetch(payments_base_url + payments_api_version + "/member/status", {
            method:"POST",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body:JSON.stringify(params)
        });
    },

    memberCreate: function(params) {
        return fetch(payments_base_url + payments_api_version + "/member/create", {
            method:"POST",
            headers,
            body:JSON.stringify(params)
        });
    },

    memberUpdate: function(params) {
        return fetch(payments_base_url + payments_api_version + "/member/update", {
            method:"POST",
            headers,
            body:JSON.stringify(params)
        });
    },

    getIpAddress: function(params) {
        return fetch(payments_base_url + payments_api_version + "/functions/get-ip-address", {
            method:"GET",
            headers,
            body:JSON.stringify(params)
        }).then((response) => response.json())
        .then((responseJson) => {return responseJson});
    }
};

export default ApiService;